import { useState } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import help_img from "../../assets/images/help-img.svg";
import phone_icon from "../../assets/images/phone-icon.svg";
import email_icon from "../../assets/images/email-icon.svg";
import "./ayuda.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatTelefono } from "../../helpers/formatTelefono";

export const AyudaScreen = () => {
  const { email_informacion, telefono_informacion } = useSelector(
    (state) => state.auth
  );
  const { t } = useTranslation();

  const [tel, setTel] = useState(
    telefono_informacion !== null ? telefono_informacion : t("ayuda.telefono")
  );

  const [mail, setMail] = useState(
    email_informacion !== null ? email_informacion : t("ayuda.email")
  );

  return (
    <>
      <Container className="content-body mt-4 mb-4 px-4">
        <Container className="mt-1">
          <Row className="content-section">
            <Row className="no-flota mt-1" style={{ textAlign: "center" }}>
              <Col xs={12} lg={{ span: 8, offset: 2 }}>
                <Image
                  src={help_img}
                  fluid="true"
                  className="flotas-image-info"
                />
                {/* <h2>{t("flotas.no-flotas.h2")}</h2> */}
                <h2>{t("ayuda.h2")}</h2>
                <div className="d-grid gap-2">
                  <Row>
                    <Col xs={12} lg={{ span: 8, offset: 2 }}>
                      <p>{t("ayuda.p")}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={12}
                      md={{ span: 4, offset: 2 }}
                      className="mt-3 mt-md-0"
                    >
                      <a href={`tel:${tel}`} className="ayuda-help-link">
                        <img
                          src={phone_icon}
                          alt={t("ayuda.help.phone")}
                          className="ayuda-help-icon"
                        />
                        <span className="ayuda-help-phone">
                          {formatTelefono(tel)}
                        </span>
                      </a>
                    </Col>
                    <Col xs={12} md={4} className="mt-3 mt-md-0">
                      <a href={`mailto:${mail}`} className="ayuda-help-link">
                        <img
                          src={email_icon}
                          alt={t("ayuda.help.phone")}
                          className="ayuda-help-icon"
                        />
                        <span className="ayuda-help-phone">{mail}</span>
                      </a>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Row>
        </Container>
      </Container>
    </>
  );
};
